import * as React from 'react';
import { StyleSheet, Platform, View, Dimensions } from 'react-native';
import { translate } from 'secullum-i18n';
import { isTablet, Card, CheckBox, Text } from 'secullum-react-native-ui';
import { getTheme } from '../modules/layout';

interface Props {
  checked?: boolean;
  showChecked?: boolean;
  onChecked?: (value: boolean) => void;
  gerente?: boolean;
}

class AssinaturaDigitalCartaoPontoHeader extends React.Component<Props> {
  render() {
    const { onChecked, checked, showChecked, gerente } = this.props;

    const fontSize = Platform.OS == 'web' ? 14 : isTablet() ? 15 : 12;

    const webDesktop =
      Platform.OS === 'web' && Dimensions.get('window').width >= 900;

    return (
      <Card.Section style={styles.headerContainer}>
        {showChecked ? (
          <CheckBox
            nativeID="solicitacao-checkbox-todos"
            value={checked!}
            onChange={onChecked}
          />
        ) : (
          <View style={styles.placeholderCheckbox} />
        )}
        <Text
          bold
          flex={webDesktop ? 0.2 : 0.4}
          size={fontSize}
          color={theme.textColor3}
          style={[styles.headerText]}
        >
          {translate('Número')}
        </Text>
        <Text
          bold
          flex={webDesktop ? 1 : undefined}
          size={fontSize}
          color={theme.textColor3}
          style={[styles.headerText, { flex: 1 }]}
        >
          {translate('Descrição')}
        </Text>
        {webDesktop ? (
          <>
            {gerente && (
              <Text
                bold
                size={fontSize}
                color={theme.textColor3}
                style={[styles.headerText, { flex: 1 }]}
              >
                {translate('Funcionário')}
              </Text>
            )}
            <Text
              bold
              flex={0.5}
              size={fontSize}
              color={theme.textColor3}
              align="left"
              style={[styles.headerText, { width: isTablet() ? 50 : 40 }]}
            >
              {translate('Período')}
            </Text>
            {gerente ? (
              <>
                <Text
                  bold
                  flex={0.2}
                  size={fontSize}
                  color={theme.textColor3}
                  align="center"
                  style={[styles.headerText, { minWidth: 65 }]}
                >
                  {translate('Resposta Gerente')}
                </Text>
                <Text
                  bold
                  flex={0.2}
                  size={fontSize}
                  color={theme.textColor3}
                  align="center"
                  style={[styles.headerText, { minWidth: 85 }]}
                >
                  {translate('Resposta Funcionário')}
                </Text>
              </>
            ) : (
              <Text
                bold
                flex={0.2}
                size={fontSize}
                color={theme.textColor3}
                align="center"
                style={[styles.headerText, { minWidth: gerente ? 65 : 0 }]}
              >
                {translate('Status')}
              </Text>
            )}
          </>
        ) : (
          <Text
            bold
            flex={0.2}
            size={fontSize}
            color={theme.textColor3}
            align="center"
            style={[styles.headerText, { minWidth: gerente ? 65 : 50 }]}
          >
            {gerente ? translate('Resposta Gerente') : translate('Status')}
          </Text>
        )}
      </Card.Section>
    );
  }
}

const theme = getTheme();

const styles = StyleSheet.create({
  headerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 6
  },
  headerText: {
    paddingRight: 5
  },
  placeholderCheckbox: {
    width: 24
  }
});

export default AssinaturaDigitalCartaoPontoHeader;
